import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SharedLanguageService } from '@language';
import {
    ShAbstractHttpService,
    ShApiCachingHelper,
    ShPaginationService,
    User,
    UserPreferences,
    UserService,
    isNotUndefined
} from '@stylehaven/components';
import { SelectionFail, SetSelection } from '../../../../state/selection/selection.actions';
import { mediaHavenSelectionSelector, shouldInitializeSelection } from '../../../../state/selection/selection.selector';
import { SharedApplicationState } from '../../../../state/shared-state.interface';
import { SetUserPreferences } from '../../../../state/user-preferences/user-preferences.actions';
import { SetUser } from '../../../../state/user/user.actions';
import { userSelector } from '../../../../state/user/user.selector';
import { MhSelection } from '../../entities/user/selection.entity';

@Injectable({ providedIn: 'root' })
export class UserStoreService extends UserService {
    protected translateService: SharedLanguageService = inject(SharedLanguageService);

    constructor(
        protected store: Store<SharedApplicationState>,
        protected http: ShAbstractHttpService,
        protected apiCachingHelper: ShApiCachingHelper,
        protected paginationService: ShPaginationService
    ) {
        super(http, apiCachingHelper, paginationService);
    }

    // #region User
    public override getCurrentUser(): Observable<User> {
        return this.store.select(userSelector).pipe(isNotUndefined());
    }

    public setUser(mediaHavenUser: User): void {
        return this.store.dispatch<SetUser>(new SetUser(mediaHavenUser));
    }
    // #endregion

    // #region User Preferences and Defaults
    public setUserPreferences(mediaHavenUserPreferences: UserPreferences): void {
        return this.store.dispatch<SetUserPreferences>(new SetUserPreferences(mediaHavenUserPreferences));
    }
    // #endregion

    // #region User Selection
    public getMhSelection(): Observable<MhSelection> {
        return this.store.select(mediaHavenSelectionSelector).pipe(
            map(selectionState => {
                if (selectionState.failed) {
                    console.error(this.translateService.instant('selection.errors.not-found'));
                }
                return selectionState.selection;
            }),
            isNotUndefined()
        );
    }

    public shouldInitializeSelection(): Observable<boolean> {
        return this.store.select(shouldInitializeSelection);
    }

    public saveMhSelection(selection: MhSelection): void {
        this.store.dispatch(new SetSelection(selection));
    }

    public setMhSelectionFailed(): void {
        this.store.dispatch(new SelectionFail());
    }
    // #endregion
}
